<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { store } from "@/store/index.js";
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Omni Tasker"
    };
  },
  beforeMount() {
    const omniLink = "http://omnitasker.com";
    const omniLink2 = "http://www.omnitasker.com";
    if (
      window.location.href.includes(omniLink) ||
      window.location.href.includes(omniLink2)
    ) {
      window.location.href = window.location.href.replace("http:", "https:");
    }
  }
};
</script>

<style>
@import "./assets/css/CustomControls.css";
@import "./assets/css/SidebarTable.css";
@import "./assets/css/DarkTheme.css";
@import "./assets/css/CssVars.css";

@font-face {
  font-family: Saira;
  /* font-display: auto; */
  src: url(~./assets/fonts/Saira.ttf);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  outline: 0;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Saira" !important;
  overflow: hidden !important;
}

.v-dialog.active .v-dialog-overlay {
  background: rgba(0, 0, 0, 0.75) !important;
}

.mx-datepicker {
  font-family: inherit !important;
  min-height: 40px !important;
  display: block !important;
  padding: 0 !important;
  width: 100% !important;
  border-radius: 5px !important;
  /* border: 1px solid #e8e8e8 !important; */
  background: #fff !important;
}

.mx-input-wrapper > .mx-input {
  display: inline-block !important;
  width: 100% !important;
  height: 40px !important;
  padding: 0 !important;
  padding-left: 10px !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  color: #555 !important;
  background-color: #fff !important;
  /* border: 0 !important; */
  border-radius: 4px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.mx-datepicker-popup {
  left: 0px !important;
  right: auto !important;
  bottom: 100% !important;
  background-color: #fff !important;
}

.mx-input-append {
  display: none !important;
}

.mx-calendar {
  background-color: #fff !important;
  border: 1px solid #e8e8e8 !important;
}

.mx-datepicker-footer {
  background-color: #fff !important;
  border: 1px solid #e8e8e8 !important;
  border-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue